import {
  Dialog,
  DialogTitle,
  IconButton,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

/**
 * Drop-in replacement for MUI Dialog that goes full-screen on mobile (xs/sm).
 *
 * Extra props (beyond standard MUI Dialog):
 *   title   - Dialog heading string
 *   onClose - Called when the X icon button is tapped (mobile full-screen only)
 *
 * All other props are forwarded to the underlying MUI Dialog.
 */
const ResponsiveDialog = ({ title, onClose, children, ...props }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog {...props} fullScreen={fullScreen}>
      <DialogTitle sx={{ pr: fullScreen ? 6 : 3 }}>
        {title}
        {fullScreen && (
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "text.secondary",
            }}
          >
            <CloseRoundedIcon />
          </IconButton>
        )}
      </DialogTitle>
      {children}
    </Dialog>
  );
};

export default ResponsiveDialog;
